import * as Sentry from "@sentry/react";
import { fetchAuthSession } from "aws-amplify/auth";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import { useGetCustomer } from "../api/customers";
import useAuthStore from "../stores/authStore";
import useBomWizardStore from "../stores/bomWizardStore";
import useFileImportStore from "../stores/fileImportStore";

export default function useInitialState() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [tokensLoading, setTokensLoading] = useState(true);
  const { isPending: customerIsPending } = useGetCustomer({ enabled: !tokensLoading });

  useEffect(() => {
    fetchAuthSession()
      .then(({ tokens }) => {
        if (!tokens?.accessToken || !tokens?.idToken) {
          return;
        }
        const accessToken = tokens.accessToken.toString();
        const idToken = tokens.idToken.toString();
        const payload = tokens.idToken.payload;
        Sentry.setUser({ email: payload.email });
        useAuthStore.getState().setCredentials({ accessToken, idToken, idTokenPayload: payload });
      })
      .catch((err) => {
        Sentry.captureException(err);
      })
      .finally(() => {
        setTokensLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!tokensLoading) {
      if (!customerIsPending) {
        setLoading(false);
      } else {
        setLoading(true);
      }
    } else {
      setLoading(true);
    }

    return () => {
      setLoading(true);
    };
  }, [tokensLoading, customerIsPending]);

  useEffect(() => {
    if (location && !location.pathname.includes("import-bom-csv")) {
      useFileImportStore.getState().clearState();
    }

    if (location && !location.pathname.includes("create-bill-of-material")) {
      useBomWizardStore.getState().clearState();
    }
  }, [location]);

  return useMemo(
    () => ({
      loading,
    }),
    [loading],
  );
}
